<template>
    <ul>
        <li class="inbox-sidebar-header">
            {{section.title}}
        </li>
        <received-files-sidebar-entry v-for="entry in section.entries" :key="entry.name" :entry="entry"></received-files-sidebar-entry>
    </ul>
</template>
<script>
import ReceivedFilesSidebarEntry from './received-files-sidebar-entry'

export default {
    props: {
        section: Object
    },
    components: {
        ReceivedFilesSidebarEntry
    }
}
</script>
<style scoped>
.inbox-sidebar-header {
    padding: 1em 0.75em 0em;
    text-transform: uppercase;
    font-size: 0.9em;
    font-weight: 600;
    width: 100%;
    color: #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-sidebar-section.vue